import { FC, memo } from 'react';
import { FormTotalsRowPosition } from 'src/shared/store/projects/types';

interface TotalsRowViewSettingsProps {
  label: string;
  position: FormTotalsRowPosition;
  onLabelChange: (value: string) => void;
  onPositionChange: (value: FormTotalsRowPosition) => void;
}

const positionOptions: Array<{ value: FormTotalsRowPosition; label: string }> = [
  { value: 'end', label: 'В конце' },
  { value: 'start', label: 'В начале' },
];

export const TotalsRowViewSettings: FC<TotalsRowViewSettingsProps> = memo(
  ({ label, position, onLabelChange, onPositionChange }) => (
    <div className="mt-3 rounded border border-blue-400 p-3">
      <div className="mb-3 text-xs opacity-70 dark:text-white">Строка итогов</div>
      <div className="grid grid-cols-2 gap-3">
        <label className="flex flex-col gap-2 text-xs dark:text-white" htmlFor="totals-row-label">
          Название строки итогов
          <input
            id="totals-row-label"
            value={label}
            onChange={event => onLabelChange(event.target.value)}
            className="rounded border border-violet-400 bg-white p-2 text-xs dark:border-violet-900 dark:bg-violet-1200 dark:text-white"
          />
        </label>

        <label
          className="flex flex-col gap-2 text-xs dark:text-white"
          htmlFor="totals-row-position"
        >
          Позиция строки итогов
          <select
            id="totals-row-position"
            aria-label="Позиция строки итогов"
            value={position}
            onChange={event => onPositionChange(event.target.value as FormTotalsRowPosition)}
            className="rounded border border-violet-400 bg-white p-2 text-xs dark:border-violet-900 dark:bg-violet-1200 dark:text-white"
          >
            {positionOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  ),
);
